// import "./data/ExplerimentsLabs/exploreNextLong/intent/conceptEngine";
import logo from "./logo.svg";
import "./App.css";

import "primeflex/primeflex.css";

import React, { useEffect, useContext, lazy, Suspense, useState, useRef } from "react";
import { Routes, Route, useLocation, useMatch, useParams,  Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Alert from "./component/Alert";
import Home from "./component/Home";
import Nav from "./component/Nav";
import Footer from "./component/Footer";
import Services from "./component/Services";
import Tools from "./component/Tools";
import About from "./component/About";
import Privancy from "./component/Privancy";
import Contact from "./component/Contact";



import { BlogDetail, BlogBack } from "./component/BlogDetail";
import { CartProvider } from "./component/CartContext";
import { BlogAudioProvider, BlogAudioContext } from "./component/BlogAudioContext";
import BlogAudioPlayer from "./component/BlogAudioPlayer";
import { getOrSetUserId } from "./analytics";
import { toast } from "react-toastify";
import { useFirstVisit } from "./utils/useFirstVisit";
import { checkMetaInApp, timeForPage, trackEvent } from "./component/UtilsFunction";

import { AppStatusElement } from "./component/AppStatusElement";
import { ScrollEventForGa } from "./component/TrackingTimeonPage";
import Loader from "./component/Loader";
import("./component/ExploreNext");

// import "./data/ExperimentsLabs/exploreNextLong/experiment";


// import { initializeWebRecording } from "./utils/WebRecording"
// import { requestPermission } from "./component/FireBase";
// import InstagramOverlay from "./component/InstagramOverlay"

// Lazy-loaded heavy pages

const ExploreMasonry = lazy(() => import("./component/ExploreMasonry"));
// const ExploreMasonic = lazy(() => import("./component/ExploreMasonic"));
const Blogs = lazy(() => import("./component/Blogs"));
const ExploreNext = lazy(() => import("./component/ExploreNext"));

const Products = lazy(() => import("./component/Products"));
const TextToBold = lazy(()=> import("./component/TextToBold"))
const HtmlToText = lazy(()=> import("./component/HtmlToText"))
const CaptionIdeas = lazy(() => import("./component/CaptionIdeas"));

function App() {
  const location = useLocation();
  const isMetaInApp = checkMetaInApp()
  const matchRoute = useMatch("/blog-detail/:blogId/:blogTitle");
  const exploreNext = useMatch("/explore-next/:type/:imageTag");
  const exploreNextParams = exploreNext?.params;
  const exploreRoute = useMatch("/explore");
  const BlogRoute = useMatch("/blogs");
  const toolRoute = useMatch("/tools/*")
  const serviceRoute = useMatch("/services")
  const CaptionsRoute = useMatch("/captions/*")
  const ExploreRoute = useMatch("/explore")
  
  const toolsRoute = toolRoute || serviceRoute || CaptionsRoute || ExploreRoute
  
  
  const blogBackProps = exploreNext
  ? {
      page: "explore-next",
      type: exploreNext.params.type,
      imageTag: exploreNext.params.imageTag,
      pathname: exploreNext.pathname,
    }
  : matchRoute
  ? {
      page: "blog-detail",
      blogId: matchRoute.params.blogId,
      blogTitle: matchRoute.params.blogTitle,
      pathname: matchRoute.pathname,
    }
  : null;

  
  useEffect(()=>{
     const cleanup = ScrollEventForGa();

  return () => {
    cleanup && cleanup();
  };


  }, [])

  useEffect(() => {
    if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;

    if (window.gtag) {
      const userId = getOrSetUserId();
      const isOwner = userId.startsWith("uid-1758");

      window.gtag("event", "page_view", {
               page_title: document.title,
              page_location: window.location.href,
              page_path: location.pathname,
              is_owner: isOwner ? "yes" : "no"
  
        
      });
    }


  }, [location]);

//   useEffect(()=>{
// console.log("now app render", location.pathname)
//     if(location.pathname !== "/blogs" && location.pathname !== "/tools" && location.pathname !== "/products"){
//             const lastToastTime = localStorage.getItem("dailyVisits");
//           const now = Date.now();

//           // 24 hours in milliseconds
//           const ONE_DAY = 24 * 60 * 60 * 1000;

//           if (!lastToastTime || now - parseInt(lastToastTime, 10) > ONE_DAY) {
//             setTimeout(()=>{
//               toast.info("Welcome to BrowseNext again! Images updated in every hour",{
//                 className: "browseToast"
//               });

//             }, 5000)
//             localStorage.setItem("dailyVisits", now.toString());
//           }

//     }



//     // ✅ Show welcome message for *new users only*
//    const hasVisited = localStorage.getItem("hasVisitedBrowseNext");
//     if (!hasVisited) {
//         setTimeout(() => {
//           // toast.success("Welcome to BrowseNext! Scroll to Discover World's popular images");
//           toast.success("Welcome to BrowseNext... Scroll to explore trending images", {
//                       autoClose: false,   // 👈 stays visible until closed manually
//                       closeOnClick: true, // 👈 allow user to close by clicking
//                       draggable: true,    // optional, lets user drag to dismiss
//                       pauseOnHover: true, // optional, prevents closing on hover
//                       className: "browseToast"
//           });
//         }, 1200);
//         localStorage.setItem("hasVisitedBrowseNext", "true");
//       }
    
//   }, [])

  // Set cookie for previous path
  
  function trackReturnVisit() {
  if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") {
    return;
  }

  const sessionKey = "bn_return_visit_tracked";
  const lastVisitKey = "bn_last_visit";

  // Track only once per browser session.
  if (sessionStorage.getItem(sessionKey)) {
    return;
  }

  const now = Date.now();
  const lastVisit = localStorage.getItem(lastVisitKey);

  if (lastVisit && window.gtag) {
    const daysSincePreviousVisit = Math.floor(
      (now - Number(lastVisit)) / (1000 * 60 * 60 * 24)
    );

    trackEvent("return_visit", {
      // days_since_previous_visit: daysSincePreviousVisit,
      deviceWidth: `${timeForPage()}-${daysSincePreviousVisit}` 
    });
  }

  sessionStorage.setItem(sessionKey, "true");
  localStorage.setItem(lastVisitKey, now.toString());
}

  
  useEffect(() => {
  console.log("now app render", location.pathname);
  trackReturnVisit()

  if (
    location.pathname === "/blogs" ||
    location.pathname === "/tools" ||
    location.pathname === "/products"
  ) {
    return;
  }

  const now = Date.now();
  const ONE_DAY = 24 * 60 * 60 * 1000;

  const hasVisited = localStorage.getItem("hasVisitedBrowseNext");
  const lastToastTime = localStorage.getItem("dailyVisits");

  // ✅ 1. NEW USER → show welcome toast ONLY
  // && window.innerWidth <= 580
  if (!hasVisited) {
    // setTimeout(() => {
    //   toast.success(
    //     "Welcome to BrowseNext... Scroll to explore trending images",
    //     {
    //       autoClose: 5000,   
    //       closeOnClick: true,
    //       draggable: true,
    //       pauseOnHover: true,
    //       className: "browseToast",
    //     }
    //   );
    // }, 1200);

    localStorage.setItem("hasVisitedBrowseNext", "true");
    return; 
  }

  // ✅ 2. RETURNING USER → show daily toast (once per 24h)
  if (!lastToastTime || now - parseInt(lastToastTime, 10) > ONE_DAY) {
    setTimeout(() => {
      toast.info(
        "Welcome back on BrowseNext!",
        { className: "browseToast" }
      );
    }, 5000);

    localStorage.setItem("dailyVisits", now.toString());
  }

  
}, []);



  
  useEffect(() => {
    const setCookie = (name, value, days) => {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    };
    setCookie("userCookie", location.pathname, 30);

    // document.body.style.overscrollBehavior = location.pathname === "/explore" ? "contain" : "";
  }, [location]);

  // Set --vh CSS variable
  useEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    };
    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

   const [savedImages, setSavedImages] = useState([]);
  const [imageSavedStates, setSavedImageState] = useState([]);
  const PAGE_SIZE = 20;
const [savedPage, setSavedPage] = useState(1);
const loadingRef = useRef(false);

    const fetchSavedImages = async (page = 1) => {
      console.log("fetched locations", location.pathname)
      // if(location.pathname === "/" || location.pathname === "/blogs") return 
      if(location.pathname === "/products") return
      const chunkSize = 3; // ⭐ only 3 requests at a time
let freshImages = [];

          const imagesFromStorage = JSON.parse(localStorage.getItem("savedImages")) || [];
        // const imageIds = imagesFromStorage.map(img => img.id);
        const start = (page - 1) * PAGE_SIZE;
const end = start + PAGE_SIZE;

if (start >= imagesFromStorage.length) {
  loadingRef.current = false;
  return;
}
// const imageIds = imagesFromStorage.slice(start, end).map(img => img.id);
const pageImages = imagesFromStorage.slice(start, end);

      try {
        // const promises = imageIds.map(async (id) => {
        //   const response = await fetch(`https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q&id=${id}`);
        //   const data = await response.json();
        //   // Pixabay returns hits array
        //   return data.hits[0]; // return the image object
        // });

        for (let i = 0; i < pageImages.length; i += chunkSize) {
  const batch = pageImages.slice(i, i + chunkSize);

  const results = await Promise.all(
    batch.map(async (img) => {
        if (img._source === "pexels") {
        return img;
      }
      const response = await fetch(
        `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&id=${img.id}`
      );
      const data = await response.json();
      return data.hits[0];
    })
  );

  freshImages.push(...results.filter(Boolean));
}

        // const freshImages = await Promise.all(promises);
        // const validImages = freshImages.filter(Boolean); 
        const validImages = freshImages
        // const validImages = freshImages.filter(Boolean).reverse();

        // setSavedImages(validImages);
        setSavedImages(prev =>
  page === 1
    ? validImages
    : [...prev, ...validImages]
);




        
        // ⬇ main change: preserve old loaded states

// setSavedImageState((prevStates) =>
//   validImages.map((img) => {
//     const prevIndex = savedImages.findIndex((p) => p.id === img.id);
//     if (prevIndex !== -1 && prevStates[prevIndex]?.loaded) {
//       return { loaded: true }; // keep old state
//     }
//     return { loaded: false }; // reset only new images
//   })
// );

setSavedImageState(prevStates => [
  ...(page === 1 ? [] : prevStates),
  ...validImages.map(() => ({
    loaded: false
  }))
]);


     return validImages; 

      } catch (err) {
        console.error("Failed to fetch saved images:", err);
      }finally{
        loadingRef.current = false; // ← fetch completed
      }
    }



useEffect(() => {
  if (savedPage > 1) {
    fetchSavedImages(savedPage);
  }
}, [savedPage]);

 const { storageReady , showAppStatus, dismissAppStatus } = useFirstVisit();
 const [hideExploreStatus, setHideExploreStatus] = useState(false);
 const [showAppStatusOnDelay, setAppStatusOnDelay] = useState(false)
let offsetClass = "";

if (localStorage.getItem("clickExploreNextTop") || !(storageReady && showAppStatus)) {
  if (exploreRoute || !exploreNext) {
    offsetClass = "pt-ps90";
  }
  else {
    offsetClass = "mt-ps90";
  }
}else if(toolsRoute || BlogRoute || matchRoute){
  offsetClass = "mt-ps90";
}

useEffect(() => {
  const isClicked = localStorage.getItem("clickExploreNextTop") === "true";
  if (isClicked) {
    
      setHideExploreStatus(true);
  

    
  }
}, []);





// 🔥 ExploreNext page
if (exploreNext) {
  // Add padding ONLY if first visit status is active
  if (storageReady && showAppStatus) {
    offsetClass = "pt-ps90 use_explore_padding";
  } else {
    offsetClass = "pt-ps90 use_explore_padding";
  }
}

// 🔹 Other pages (existing logic)
else if (!(storageReady && showAppStatus)) {
  offsetClass = exploreRoute ? "pt-ps90" : "mt-ps90";
}

const [triggerExploreStart, setTriggerExploreStart] = useState(0);
const imageData = location.state?.imageData;
const blogData = location.state?.blogData;
const userComeFrom = (imageData || blogData)

// const [routerReady, setRouterReady] =
//   useState(false);

// useEffect(() => {

//   setRouterReady(true);

// }, []);


// console.log("Is external user:", );
// if (!routerReady) {
//   return <Loader />;
// }

  return (
    <>
    
    {/* <InstagramOverlay /> */}
       <BlogAudioProvider>
      <CartProvider>

        {/* Conditional Nav / BlogBack */}
        {(matchRoute || exploreNext) ? (<>
        
        {/* {((matchRoute || exploreNext) && (userComeFrom)) ? (<> */}
          
          <BlogBack componentFrom={blogBackProps} />
          </>
        ) : (
          <Nav trackCart={false}      
           setSavedImageState={setSavedImageState}
                 savedImages={savedImages}
        imageSavedStates={imageSavedStates}
                fetchSavedImages={fetchSavedImages}  setSavedImages={setSavedImages} 
                 savedPage={savedPage}
  setSavedPage={setSavedPage}
                loadingRef={loadingRef}
                 />
        )}
   {/* !exploreNext &&  */}
      {!exploreNext && !toolsRoute && !BlogRoute && !matchRoute && storageReady && showAppStatus && !hideExploreStatus  && <AppStatusElement  onClose={dismissAppStatus} imageTag={exploreNextParams?.imageTag}   
      onStartExplore={() => {
     setTimeout(()=>{
   localStorage.setItem("clickExploreNextTop", "true")
        setHideExploreStatus(true)
     }, 500)
        setTriggerExploreStart(prev => prev + 1)
      }}/>}
      
   
        {/* Routes */}
       <div className={offsetClass}>
        <Routes>
          <Route path="/sitemap.xml" element={null} />
          
          
          <Route path="/" element={<Home fetchSavedImages={fetchSavedImages} />} />
          <Route
            path="/explore"
            element={
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Explore...</div>}>
                <ExploreMasonry dismissAppStatus={dismissAppStatus}   fetchSavedImages={fetchSavedImages}    />
                {/* <ExploreMasonic dismissAppStatus={dismissAppStatus}   fetchSavedImages={fetchSavedImages}    /> */}
              </Suspense>
            }
          />
          <Route
            path="/blogs"
            element={
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Blogs...</div>}>
                <Blogs />
              </Suspense>
            }
          />
          <Route
            path="/blogs/search"
            element={
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Blogs...</div>}>
                <Blogs />
              </Suspense>
            }
          />
          <Route
            path="/blogs/suggest"
            element={
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Blogs...</div>}>
                <Blogs />
              </Suspense>
            }
          />
          <Route
            path="/products"
            element={
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Products...</div>}>
                <Products />
              </Suspense>
            }
          />
       

          <Route path="/tools" element={<Tools />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/privacy" element={<Privancy />} />
          <Route path="/contact" element={<Contact />} />
             <Route path="/tools/bold-text-generator"  element={ <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading...</div>}>
                <TextToBold fetchSavedImages={fetchSavedImages} />
              </Suspense>
            }
          />

          <Route path="/tools/bold-caption"  element={ <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading...</div>}>
                <TextToBold fetchSavedImages={fetchSavedImages} />
              </Suspense>
            }
          />

          <Route path="/tools/html-to-markdown"  element={ <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading...</div>}>
                <HtmlToText fetchSavedImages={fetchSavedImages} />
              </Suspense>
            }
          />
          
          <Route
            path="/blog-detail/:blogId/:blogTitle"
            element={
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Blog Detail...</div>}>
                <BlogDetail fetchSavedImages={fetchSavedImages}  />
              </Suspense>
            }
          />
          <Route
            path="/explore-next/:type/:imageTag"
            element={
              // <Suspense fallback={<Loader />}>
              <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Explore Next...</div>}>
                <ExploreNext fetchSavedImages={fetchSavedImages}  triggerExploreStart={triggerExploreStart} setHideExploreStatus={setHideExploreStatus} />
              </Suspense>
            }
          />
          <Route
            path="/captions/:category"
            element={
                    <Suspense fallback={<div className="d-flex justify-content-center align-items-center">Loading Captions...</div>}>
                      <CaptionIdeas />
                    </Suspense>
                  }
          />
          <Route path="/services" element={<Services />} />
          
          <Route path="*" element={<Navigate to="/explore" replace />} />
          <Route path="/captions/*" element={<Navigate to="/captions/love" replace />} />
        </Routes>

       </div>
        <Alert position="bottom-center"> </Alert> 

        <BlogAudioPlayer />
        {!exploreNext && !exploreRoute && <Footer />}
        {(!isMetaInApp) && <Analytics />}
        

      </CartProvider>
    </BlogAudioProvider>


    </>
 
    
  );
}

export default App;
